export function convertDate(date: string | Date): Date | null {
  const parsedDate = new Date(typeof date === 'string' ? date.replace(/\+([0-9]{2}):?([0-9]{2})/g, '+$1:$2') : date);
  return isNaN(parsedDate.getTime()) ? null : parsedDate;
}
